export default __webpack_public_path__ + "src/assets/icn-checkmark-white.53cbb78884b397e98b22e8f1a96eab47.svg";